module.exports = __webpack_public_path__ + "img/gna-logo.de0af1a0.png";